export enum VMHAEventPhase {
  InProgress = 'inprogress',
  Completed = 'completed',
}

export enum VMHATaskPhase {
  Queued = 'queued',
  InProgress = 'inprogress',
  Skipped = 'skipped',
  Error = 'error',
  Completed = 'completed',
}

export enum VMHABannerState {
  InProgress = 'inprogress',
  Completed = 'completed',
  Warning = 'warning',
  Error = 'error',
}

export interface VMHAEventMetric {
  __name__: string
  cluster: string
  host_id: string
  instance: string
  job: string
  phase: VMHAEventPhase
  total_vms: string
  ts: string
  vmha_uuid: string
}

export interface VMHAEventResult {
  metric: VMHAEventMetric
  values: [number, string][]
}

export interface VMHAEventsResponse {
  status?: string
  isPartial?: boolean
  data?: {
    resultType: string
    result: VMHAEventResult[]
  }
  stats?: {
    seriesFetched: string
    executionTimeMsec: number
  }
}

export interface VMHATaskMetric {
  __name__: string
  cluster: string
  fault?: string
  host_id: string
  instance: string
  job: string
  phase: VMHATaskPhase
  power_state?: string
  reason?: string
  status?: string
  task?: string
  task_state?: string
  ts: string
  vm_id: string
  vm_state?: string
  vmha_uuid: string
}

export interface VMHATaskResult {
  metric: VMHATaskMetric
  value: [number, string]
}

export interface VMHATaskDetailsResponse {
  status?: string
  isPartial?: boolean
  data?: {
    resultType: string
    result: VMHATaskResult[]
  }
  stats?: {
    seriesFetched: string
    executionTimeMsec: number
  }
}

export interface VMHAEvent {
  hostId: string
  phase: VMHAEventPhase
  totalVms: string
  timestamp: string
  vmhaUuid: string
  cluster: string
  eventTimestamp: number
  instanceName: string
  reason?: string
}

export interface VMHATaskDetail {
  vmId: string
  phase: VMHATaskPhase
  timestamp: string
  reason?: string
  fault?: string
  status?: string
  task?: string
  taskState?: string
  vmState?: string
  tenant?: string
  ipAddress?: string
  targetHost?: string
}

export interface VMHAHostStatus {
  hostId: string
  event: VMHAEvent
  tasks: VMHATaskDetail[]
  state: VMHABannerState
  eventOccurrenceTime: string
}
